const buildConversationsStorageKey = (posthogProjectKey: string): string =>
  `ph_conv_${posthogProjectKey.trim()}`;

export const persistPosthogConversationsWidgetOpen = (posthogProjectKey: string): void => {
  if (typeof window === "undefined" || posthogProjectKey.trim().length === 0) {
    return;
  }

  const storageKey = buildConversationsStorageKey(posthogProjectKey);

  try {
    const existing = JSON.parse(window.localStorage.getItem(storageKey) ?? "{}") as Record<
      string,
      unknown
    >;
    window.localStorage.setItem(storageKey, JSON.stringify({ ...existing, widgetState: "open" }));
  } catch {
    // Ignore corrupt PostHog conversations storage.
  }
};

export const persistPosthogConversationsWidgetClosed = (posthogProjectKey: string): void => {
  if (typeof window === "undefined" || posthogProjectKey.trim().length === 0) {
    return;
  }

  const storageKey = buildConversationsStorageKey(posthogProjectKey);

  try {
    const existing = JSON.parse(window.localStorage.getItem(storageKey) ?? "{}") as Record<
      string,
      unknown
    >;
    window.localStorage.setItem(storageKey, JSON.stringify({ ...existing, widgetState: "closed" }));
  } catch {
    // Ignore corrupt PostHog conversations storage.
  }
};
